export function TagUser({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.5 2.25H13.5C14.3373 2.25 15 2.91828 15 3.72754V11.9102C14.9999 12.7226 14.334 13.3945 13.5 13.3945H12.9297C12.1454 13.3946 11.3766 13.7013 10.8125 14.2637L9.53027 15.5312C9.2374 15.8202 8.7626 15.8202 8.46973 15.5312L7.18652 14.2637C6.62244 13.7016 5.85442 13.3946 5.07031 13.3945H4.5C3.666 13.3945 3.00009 12.7226 3 11.9102V3.72754C3 2.91828 3.66265 2.25 4.5 2.25ZM9 3.41211C7.77196 3.41211 6.79156 4.4108 6.78027 5.61816V5.625C6.78027 6.38013 7.15301 7.04173 7.72461 7.44043C7.29609 7.55405 6.88575 7.72931 6.52246 7.9707L6.52051 7.97168C5.86519 8.4102 5.43963 9.06277 5.43945 9.80859C5.43945 10.5541 5.86491 11.2045 6.52051 11.6396V11.6406C7.2361 12.1193 8.13805 12.3359 9 12.3359C9.75423 12.3359 10.5393 12.1706 11.2031 11.8086L11.4795 11.6406C12.1335 11.203 12.5604 10.5528 12.5605 9.80664C12.5605 9.06068 12.134 8.41039 11.4805 7.97266H11.4814C11.1159 7.72654 10.7004 7.55127 10.2666 7.4375C10.8365 7.03908 11.2129 6.38015 11.2129 5.625C11.2129 4.41079 10.2267 3.41211 9 3.41211Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
}
